import {Button} from '@mintdata-wsp/common/components/button/Button';
import {Form, IFormData} from '@mintdata-wsp/common/components/form/Form';
import {ErrorPopupSide} from '@mintdata-wsp/common/components/formField/FormField';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Input} from '@mintdata-wsp/common/components/input/Input';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Dialog} from '@mintdata-wsp/wsp/ui/components/forms/Dialog';
import {DialogError} from '@mintdata-wsp/wsp/ui/components/forms/DialogError';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {Spinner, SpinnerSize, SpinnerStyle} from '@mintdata-wsp/common/components/spinner/Spinner';
import {TextRun} from '@mintdata-wsp/wsp/ui/components/text/TextRun';
import {links} from '@mintdata-wsp/wsp/ui/routes/Routing';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import {RouteComponentProps} from 'react-router';

const styles = require('./ResetPasswordForm.less');
const cx = classnames.bind(styles);

@observer
export class ResetPasswordForm extends React.Component<RouteComponentProps<any>, any>
{
    private _form:Form = new Form({
        onSubmit: this._onFormSubmit,
    });

    @action
    componentDidMount()
    {
        const {resetPasswordPage} = rootState.ui;

        resetPasswordPage.isEmailSent = false;
        resetPasswordPage.isResetPasswordInProgress = false;
    }

    @bind
    private _onFormSubmit(formData:IFormData)
    {
        controllers.ui.resetPassword.submitForm(this._form);
    }

    @bind
    private _onClickSubmitButton(e:React.SyntheticEvent<any>):void
    {
        this._form.submit();
    }

    private _getSpinner(style:SpinnerStyle, className?:string):JSX.Element
    {
        return <Spinner size={SpinnerSize.Medium_24} style={style} className={cx(className)} />;
    }

    render()
    {
        const controller = controllers.ui.resetPassword;

        const {isResetPasswordInProgress, isEmailSent} = rootState.ui.resetPasswordPage;

        const title = isEmailSent ? 'Reset link sent' : 'Forgot Password?';

        const commonErrorMessage = this._form.getServerError('_');

        const email = this._form.get('email');

        return  (
            <Dialog
                className={cx('resetPasswordDialog', {isEmailSent})}
                title={title}
                >

                <DialogError message={commonErrorMessage} />

                <div className={cx('resetPasswordForm')}>

                    {!isEmailSent && (
                        <Column>

                            <TextRun className={cx('instructions')}>
                                Please enter your email address
                                and we'll send you a password reset link.
                            </TextRun>

                            <Input icon={MDIcons.common.Email}
                                   className={cx('input')}
                                   placeholder={'john@appleseed.com'}
                                   form={this._form}
                                   formKey={'email'}
                                   isInitiallyFocused={true}
                                   validationFn={controller.validateEmail}
                                   errorPopupSide={ErrorPopupSide.Right}
                            />

                            <Row className={cx('mainButtonRow')}>
                                <Button
                                    caption={'Send Reset Link'}
                                    className={cx('mainButton')}
                                    onClick={this._onClickSubmitButton}
                                    icon={isResetPasswordInProgress ? this._getSpinner(SpinnerStyle.White) : null}
                                    relativeIcon={true}
                                    isDisabled={isResetPasswordInProgress}
                                />
                            </Row>

                            <TextRun>
                                Don't have an account?
                                {links.toSignUp('Sign Up', cx('actionLink'))}
                            </TextRun>

                        </Column>
                    )}

                    {isEmailSent && (
                        <Column>

                            <TextRun className={cx('instructions')}>
                                We’ve sent an email to <span className={cx('email')}>{email}</span> with a link to reset your password.
                            </TextRun>
                            <TextRun className={cx('instructions')}>
                                Please check your email to continue.
                            </TextRun>
                            <br/>
                            <TextRun className={cx('instructions')}>
                                The link will be sent only if you’ve signed up with this email address.
                            </TextRun>
                            <TextRun className={cx('instructions')}>
                                You can also {links.toSignUp('Sign Up')} for a new account at any time.
                            </TextRun>

                            <TextRun className={cx('backText')}>
                                {links.toLogin('Back to Login')}
                            </TextRun>

                        </Column>
                    )}

                </div>

            </Dialog>
        );
    }
}
